declare global {
  interface Window {
    isEnableHideBackground?: boolean
  }
}

export const removeBackground = () => {
  window.requestAnimationFrame(() => {
    if (!window.isEnableHideBackground) {
      removeBackground()
      return
    }

    const background = document.getElementById('background')
    if (background) {
      background.style.display = 'none'
      background.style.zIndex = '-1'
      document.documentElement.style.setProperty(
        '--loading-display',
        'none',
      )
    }
  })
}
